import { type GuidanceSessionType } from '@fruitful/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { llmServiceFetcher } from '../../llm-service/LlmServiceFetcher';

export interface SimulatePostSessionWorkflowArgs {
    transcriptFixture: string;
    sessionTypeOverride?: GuidanceSessionType;
}

export const useSimulatePostSessionWorkflow = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (
            args: SimulatePostSessionWorkflowArgs,
        ): Promise<void> => {
            await llmServiceFetcher({
                endpoint: '/transcript-archived/simulate',
                method: 'POST',
                body: JSON.stringify(args),
            });
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ['workflowRuns'] });
        },
    });
};
